<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年04月22日 11:02:57 +0800
 * @最后修改时间: 2022-07-26 17:09:05
 * @FilePath: \mrc-ess-fronted\src\Page\Ess\Roster\RosterFormRecord\components\DaySelect.vue
 -->
<template>
  <v-container
    class="max-width pa-0 align-items-end align-end white text-center pb-2"
  >
    <!-- <div class="curcircle" v-if="isNow"></div> -->
    <div class="d-flex justify-end flex-column">
      <div
        class="text-h4 font-weight-medium pb-1"
        :class="isNow ? '' : 'text--secondary'"
      >
        {{ day }}
      </div>
      <div class="text-caption-xs" :class="isNow ? '' : 'text--secondary'">
        {{ $t(week) }}
      </div>
    </div>
  </v-container>
</template>
<script>
import dayjs from "dayjs";
export default {
  name: "DaySelect",
  props: { time: { default: "", type: String } },
  computed: {
    isNow() {
      if (this.time) {
        if (
          dayjs(this.time).format("YYYY-MM-DD") ===
          dayjs(new Date()).format("YYYY-MM-DD")
        ) {
          return true;
        }
      } else {
        return false;
      }
    },
    day() {
      if (this.time) {
        return dayjs(this.time).get("date");
      } else {
        return "";
      }
    },
    week() {
      if (this.time) {
        switch (dayjs(this.time).get("day")) {
          case 0:
            return "label_essweb_system_sundayLabel";
            break;
          case 1:
            return "label_essweb_system_mondayLabel";
            break;
          case 2:
            return "label_essweb_system_tuesdayLabel";
            break;
          case 3:
            return "label_essweb_system_wednesdayLabel";
            break;
          case 4:
            return "label_essweb_system_thursdayLabel";
            break;
          case 5:
            return "label_essweb_system_fridayLabel";
            break;
          case 6:
            return "label_essweb_system_saturdayLabel";
            break;
          default:
            break;
        }
      } else {
        return "";
      }
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped>
.curcircle {
  width: 50px;
  height: 50px;
  border: 2px solid var(--main-color);
  border-radius: 50px;
  position: absolute;
  margin-left: calc(50% - 25px);
  margin-top: 4px;
}
</style>
